import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBold: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBold"><Path d="M5.5 12H13.5C15.7091 12 17.5 10.0972 17.5 7.75C17.5 5.40279 15.7091 3.5 13.5 3.5H5.5V12Z" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 12H14.5C16.7091 12 18.5 13.9028 18.5 16.25C18.5 18.5972 16.7091 20.5 14.5 20.5H5.5V12" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBold;
